export default "__VITE_ASSET__CdEVBHeD__"